import React from 'react';
import { UserOutlined, MailOutlined, InboxOutlined } from '@ant-design/icons';

const REQUIREMENTS = [
  {
    icon: <UserOutlined />,
    title: 'Corresponding Author',
    text: 'La persona que se comunique con la editorial tiene que tener un vínculo jurídico con la Universidad de Oviedo.',
  },
  {
    icon: <MailOutlined />,
    title: 'Correo @uniovi.es',
    text: 'El corresponding author debe usar su correo institucional.',
  },
  {
    icon: <InboxOutlined />,
    title: 'Depósito en RUO',
    text: 'La versión final deberá ser depositada en el repositorio institucional.',
  },
];

const RequirementsComponent = () => {
  return (
    <div>
      {/* Header */}
      <div style={{ paddingTop: 28, paddingBottom: 4, textAlign: 'center', background: '#fafafa' }}>
        <div style={{
          fontSize: 22, fontWeight: 700, color: '#1a1a1a',
          letterSpacing: -0.3, lineHeight: 1.3,
          fontFamily: "'Inter','Segoe UI',sans-serif",
          padding: '0 24px',
        }}>
          Requisitos
        </div>
        <div style={{ fontSize: 13, color: '#888', marginTop: 6, paddingBottom: 16 }}>
          Condiciones necesarias para acogerse a un acuerdo transformativo
        </div>
      </div>

      <div style={{ padding: '32px 48px 48px', maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px' }}>
          {REQUIREMENTS.map((req, i) => (
            <div key={i} style={{
              background: '#fff',
              borderRadius: 10,
              boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
              borderTop: '3px solid #007398',
              padding: '28px 24px 24px',
            }}>
              <div style={{ fontSize: 30, color: '#007398', marginBottom: 14 }}>{req.icon}</div>
              <div style={{ fontSize: 16, fontWeight: 700, color: '#1a1a1a', marginBottom: 10 }}>{req.title}</div>
              <div style={{ fontSize: 13.5, color: '#555', lineHeight: 1.75 }}>{req.text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RequirementsComponent;


